import React, { useState } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { maxLength, required, composeValidators } from '../../util/validators';
import { Form, Button, FieldTextInput, FieldSelect } from '../../components';
import CustomServiceSelectFieldMaybe from './CustomServiceSelectFieldMaybe';
import UniversitySearch from './UniversitySearch';
import AzureUploadComponent from './AzureUploadComponent';
import MultiUniversitySearchSignup from './MultiUniversitySearchSignup';
import FieldCheckboxGroupBasic  from '../../components/FieldCheckboxGroup/FieldCheckboxGroupBasic';
import arrayMutators from 'final-form-arrays';


import css from './EditListingProfessionalInfoForm.module.css';

const TITLE_MAX_LENGTH = 60;

const EditListingProfessionalInfoFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        serviceOptions,
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        listing
      } = formRenderProps;

   const [gapYearValue, setGapYearValue] = useState(listing.attributes.publicData.gapYear ? listing.attributes.publicData.gapYear : "");

   const handleChange = (e) => {
    setGapYearValue(e.target.value)
  }
      

      const titleMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.title' });
      const titlePlaceholderMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.titlePlaceholder',
      });
      const titleRequiredMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.titleRequired',
      });
      const maxLengthMessage = intl.formatMessage(
        { id: 'EditListingDescriptionForm.maxLength' },
        {
          maxLength: TITLE_MAX_LENGTH,
        }
      );

      const gapYearMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.gapYear',
      });

      const descriptionMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.description',
      });
      const descriptionPlaceholderMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.descriptionPlaceholder',
      });

      const undergradMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.undergrad',
      });
      const undergradPlaceholderMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.undergradPlaceholder',
      });


      const majorMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.major',
      });
      const majorPlaceholderMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.majorPlaceholder',
      });


      const minorMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.minor',
      });
      const minorPlaceholderMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.minorPlaceholder',
      });

      const gapYearsNumberMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.gapYearsNumberMessage' });


      const schoolMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.school',
      });
      const schoolPlaceholderMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.schoolPlaceholder',
      });


      const maxLength60Message = maxLength(maxLengthMessage, TITLE_MAX_LENGTH);
      const FieldRequiredMessage = intl.formatMessage({
        id: 'EditListingProfessionalInfoForm.fieldRequired',
      });

      const { updateListingError, createListingDraftError, showListingsError } = fetchErrors || {};
      const errorMessageUpdateListing = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
        </p>
      ) : null;

      // This error happens only on first tab (of EditListingWizard)
      const errorMessageCreateListingDraft = createListingDraftError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

        const uploadFile = (uploadFunction) => {
          return uploadFunction
        }

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessageCreateListingDraft}
          {errorMessageUpdateListing}
          {errorMessageShowListing}

          <FieldTextInput
            id="undergrad"
            name="undergrad"
            className={css.description}
            type="textarea"
            label={undergradMessage}
            placeholder={undergradPlaceholderMessage}
            validate={composeValidators(required(FieldRequiredMessage))}
          />

          <FieldTextInput
            id="major"
            name="major"
            className={css.description}
            type="textarea"
            label={majorMessage}
            placeholder={majorPlaceholderMessage}
            validate={composeValidators(required(FieldRequiredMessage))}
          />

          <FieldTextInput
            id="minor"
            name="minor"
            className={css.description}
            type="textarea"
            label={minorMessage}
            placeholder={minorPlaceholderMessage}
          />

          <span>{schoolMessage}</span>
          <UniversitySearch
           listing={listing}
           defaultSchoolValue={props.defaultSchoolValue}
           id="school"
           name="school"
           className={css.description}
           track={listing.attributes.publicData.track}
           helperSignup={true}
          />

          {/* <span>{schoolMessage}</span>
          <FieldTextInput
           id="school"
           name="school"
            className={css.description}
            type="textarea"
            label={schoolMessage}
            placeholder={schoolPlaceholderMessage}
            validate={composeValidators(required(FieldRequiredMessage))}
          /> */}


          <FieldTextInput
            id="gpa"
            name="gpa"
            className={css.gpa}
            type="number"
            step=".01"
            min="0"
            max="4"
            label={"GPA"}
            placeholder={"Enter GPA score..."}
          />


{/* 
        <FieldSelect className={css.serviceResearch} name="research" id="research" label={"Were you involved in research during college?"} 
        validate={composeValidators(required(FieldRequiredMessage))}>
             <option value="" label="Were you involved in research during college?">
             </option>
              <option key="no" value="no">
               No
             </option>
             <option key="yes" value="yes">
               Yes
             </option>
         </FieldSelect> */}

         < FieldCheckboxGroupBasic 
          label={"Were you involved in research during college?"}
          options= {[
            { key: 'yes', label: 'yes' },
            { key: 'no', label: 'no' },
          ]}
          name="research"
           id="research"
          type="radio"
          validate={composeValidators(required(FieldRequiredMessage))}
         />

         {/* <FieldSelect className={css.service} name="publishResearch" id="publishResearch" label={"Have you published your research?"} 
         validate={composeValidators(required(FieldRequiredMessage))}>
             <option value="" label="Have you published your research?">
             </option>
             <option key="no" value="no">
               No
             </option>
             <option key="yes" value="yes">
               Yes
             </option>
          
         </FieldSelect> */}

         < FieldCheckboxGroupBasic 
          label={"Have you published your research?"}
          options= {[
            { key: 'yes', label: 'yes' },
            { key: 'no', label: 'no' },
          ]}
          name="publishResearch"
           id="publishResearch"
          type="radio"
          validate={composeValidators(required(FieldRequiredMessage))}
         />


         {/* <FieldSelect className={css.service} name="greekLife" id="greekLife" label={"Were you involved in greek life?"} 
         validate={composeValidators(required(FieldRequiredMessage))}>
              <option value="" label="Were you involved in greek life?">
             </option>
            <option key="no" value="no">
               No
             </option>
             <option key="yes" value="yes">
               Yes
             </option>
          
         </FieldSelect> */}


         < FieldCheckboxGroupBasic 
          label={"Were you involved in greek life?"}
          options= {[
            { key: 'yes', label: 'yes' },
            { key: 'no', label: 'no' },
          ]}
          name="greekLife"
           id="greekLife"
          type="radio"
          validate={composeValidators(required(FieldRequiredMessage))}
         />



         {/* < FieldCheckboxGroupBasic 
          label={"Were you on a varsity sports team?"}
          options= {[
            { key: 'yes', label: 'yes' },
            { key: 'no', label: 'no' },
          ]}
          name="sports"
           id="sports"
          type="radio"
          validate={composeValidators(required(FieldRequiredMessage))}
         /> */}

         <FieldSelect className={css.service} name="studyYear" id="studyYear" label={"What year are you in?"} 
         validate={composeValidators(required(FieldRequiredMessage))}>
             <option disabled hidden value="" label="What year are you in?">
             </option>
            <option key="firstYear" value="firstYear">
            First year
             </option>
             <option key="secondYear" value="secondYear">
             Second year
             </option>
             <option key="thirdYear" value="thirdYear">
             Third year
             </option>
             <option key="fourthYear" value="fourthYear">
             Fourth year
             </option>
             {/* <option key="residency" value="residency">
             Residency
             </option> */}
          
         </FieldSelect>
{/* 
         <FieldTextInput
            id="medOrDentalSchool"
            name="medOrDentalSchool"
            className={css.description}
            type="textarea"
            label={"Which med/dental schools did you receive acceptances to?"}
            placeholder={"Enter schools names here..."}
          /> */}

          <span>Which schools did you receive acceptances to?</span>
          <MultiUniversitySearchSignup
           listing={listing}
           defaultSchoolsValue={props.acceptedAtSchools}
           id="multiSchool"
           name="multiSchool"
           className={css.description}
           track={listing.attributes.publicData.track}
          />


              {/* <FieldSelect className={css.service} name="reapplicant" id="reapplicant" label={"Were you a re-applicant?"}>

                <option value="" label="Select an option">
                  
                </option>
                <option key="yes" value="yes">
                  Yes
                </option>
                <option key="no" value="no">
                  No
                </option>
             
            </FieldSelect> */}

            
         < FieldCheckboxGroupBasic 
          label={"Were you a re-applicant?"}
          options= {[
            { key: 'yes', label: 'yes' },
            { key: 'no', label: 'no' },
          ]}
          name="reapplicant"
           id="reapplicant"
          type="radio"
          validate={composeValidators(required(FieldRequiredMessage))}
         />







        {/* <FieldSelect className={css.service} name="gapYear" id="gapYear" label={gapYearMessage} gapYearOnChange={handleChange}>

                <option value="" label="Select an option">
                  
                </option>
                <option key="yes" value="yes">
                  Yes
                </option>
                <option key="no" value="no">
                  No
                </option>
             
            </FieldSelect> */}

            < FieldCheckboxGroupBasic 
              label={"Did you take a gap year?"}
              options= {[
                { key: 'yes', label: 'yes' },
                { key: 'no', label: 'no' },
              ]}
              name="gapYear"
              id="gapYear"
              type="radio"
              gapYearOnChange={handleChange}
              validate={composeValidators(required(FieldRequiredMessage))}
            />


            {gapYearValue === "yes" ? 
            <FieldTextInput
            id="gapYearsNumber"
            name="gapYearsNumber"
            className={css.title}
            type="number"
            label={gapYearsNumberMessage}
            placeholder={"enter gap years number ..."}
            autoFocus
          /> : null
          }



            {gapYearValue === "yes" ? 
                        <FieldTextInput
                        id="gapYearsActivity"
                        name="gapYearsActivity"
                        className={css.title}
                        type="textarea"
                        label={"What did you do during your gap years? Please explain. "}
                        placeholder={"write here ..."}
                        autoFocus
                      /> : null
                      }



          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingProfessionalInfoFormComponent.defaultProps = { className: null, fetchErrors: null };

EditListingProfessionalInfoFormComponent.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  serviceOptions: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
};

export default compose(injectIntl)(EditListingProfessionalInfoFormComponent);
